import React, { useState, useEffect } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import ProductCard from '../../Components/ProductCard/ProductCard';
import Pagination from '../../Components/Pagination/Pagination';
import styles from './ProductList.module.scss';
import useFetch from '../../Hooks/useFetch';
import Loader from '../../Components/Loader/Loader';

const ProductList: React.FC = () => {
  const location = useLocation();

  interface ProductType {
    id: number,
    image: string,
    title: string,
    price: string,
  }
  const { category } = useParams<any>();
  const { state: products, loading } = useFetch(`${process.env.REACT_APP_BASE_URL}/products/category/${category}`);
  const ITEMS_PER_PAGE = 4;
  const totalPage = Math.ceil(products.length / ITEMS_PER_PAGE);
  const [currentPage, setCurrentPage] = useState(0);

  const next = () => {
    setCurrentPage(currentPage < totalPage - 1 ? currentPage + 1 : currentPage);
  };

  const previous = () => {
    setCurrentPage(currentPage > 0 ? currentPage - 1 : currentPage);
  };

  const onSpecificPage = (index: number) => {
    const difference = index - currentPage;
    setCurrentPage(currentPage + difference);
  };

  const getProducts = () => products
    .slice(ITEMS_PER_PAGE * currentPage, (currentPage + 1) * ITEMS_PER_PAGE);

  useEffect(() => () => setCurrentPage(0), [location]);

  return (
    <>
      <div className="heading">
        <h1>{category.toUpperCase()}</h1>
      </div>
      <div className={styles.productContainer}>
        {loading ? (
          <>
            <Loader shimmer />
            <Loader shimmer />
            <Loader shimmer />
          </>
        ) : getProducts().map(({
          id, image, title, price,
        }: ProductType) => (
          <ProductCard
            imageUrl={image}
            description={title}
            tailing={`₹ ${price}`}
            id={id}
            shadow
            hasLink
            key={id}
          />
        ))}

      </div>
      {!loading && (
        <Pagination
          totalPage={totalPage}
          currentPage={currentPage}
          next={next}
          previous={previous}
          onSpecificPage={onSpecificPage}
        />
      )}
    </>
  );
};
export default ProductList;
